import { render, staticRenderFns } from "./BankTransactions.vue?vue&type=template&id=6f1c1344&scoped=true&"
import script from "./BankTransactions.vue?vue&type=script&lang=js&"
export * from "./BankTransactions.vue?vue&type=script&lang=js&"
import style0 from "./BankTransactions.vue?vue&type=style&index=0&id=6f1c1344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c1344",
  null
  
)

export default component.exports